<template>
  <div class="mdl-layout__drawer">
    <span class="mdl-layout-title">Menu</span>
    <nav class="mdl-navigation">
      <router-link class="mdl-navigation__link" to="/calendar" @click.native="hideMenu"><i class="material-icons">calendar_today</i> Agenda</router-link>
      <router-link class="mdl-navigation__link" to="/changes" @click.native="hideMenu" v-if="demo"><i class="material-icons">swap_horiz</i> Substituição de Equipe</router-link>        
      <router-link class="mdl-navigation__link" to="/inbox" @click.native="hideMenu" v-if="demo"><i class="material-icons">mail_outline</i> Comunicados</router-link>
      <router-link class="mdl-navigation__link" to="/outbox" @click.native="hideMenu" v-if="demo"><i class="material-icons">message</i> Solicitações</router-link>
      <router-link class="mdl-navigation__link" to="/surveys" @click.native="hideMenu" v-if="demo"><i class="material-icons">live_help</i> Questionários</router-link>
    </nav>
  </div>
</template>
<script>
  import 'material-design-lite'
  export default {
    name: 'SideMenu',
    data: function() {
      return {
        demo: process.env.FSM_DEMO
      }  
    },
    mounted() {
      componentHandler.upgradeAllRegistered();
    },
    methods: {
      hideMenu: function () {
        document.getElementsByClassName('mdl-layout__drawer')[0].classList.remove('is-visible')
        document.getElementsByClassName('mdl-layout__obfuscator')[0].classList.remove('is-visible')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SideMenu.vue